import axios from "axios"
import loginService from "./loginService"
import imageService from "./imageService"
import { BASE_SERVER_URL } from "../constants"

/**
 * 
 * @param {ObjectId} id 
 * @returns Promise
 */
const getEvent = (id) => {
    const URL = `${BASE_SERVER_URL}/event/${id}`
    return axios.get(URL)
        .then(ret => {
            return ret.data
        }).catch(err => err)

}

/**
 * Backend model: event.js
 * @returns 
 */
const postEvent = (name, organizedOn, venue, file, eventType, article) => {
    const URL = `${BASE_SERVER_URL}/event`
    const event = { name, organizedOn, venue, eventType, article }
    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            if (file) {
                // upload image
                return imageService.uploadImage(file)
                    .then(imgres => {
                        event.fileUrl = imgres.fileUrl
                        // upload event with image url
                        return axios.post(URL, event, config)
                            .then(ret => {
                                return { articleResponse: ret, imageResponse: imgres }
                            }).catch(err => err)
                    }).catch(err => err)
            } else {
                // only upload event
                return axios.post(URL, event, config)
                    .then(ret => {
                        return ret
                    }).catch(err => err)
            }
        })
}

const updateEvent = (id, name, organizedOn, venue, file, oldFileUrl, eventType, article) => {
    const URL = `${BASE_SERVER_URL}/event/${id}`
    console.log("event file", file)

    const event = { name, organizedOn, venue, eventType, article}
    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            if (file) {
                // upload / update image
                return oldFileUrl ?
                    imageService.updateImage(file, imageService.extractFileNamefromFileUrl(oldFileUrl))
                        .then((imgres) => {
                            // update event
                            event.fileUrl = imgres.fileUrl
                            return axios.put(URL, event, config)
                                .then(eventres => {
                                    return { articleResponse: eventres.data, imageResponse: imgres.data }
                                }).catch(err => err)
                        }).catch(err => err)
                    :
                    imageService.uploadImage(file)
                        .then((imgres) => {
                            // update event
                            event.fileUrl = imgres.fileUrl
                            return axios.put(URL, event, config)
                                .then(eventres => {
                                    return { articleResponse: eventres.data, imageResponse: imgres.data }
                                }).catch(err => err)
                        }).catch(err => err)
            } else {
                // without new image
                return axios.put(URL, event, config)
                    .then(ret => {
                        return ret.data
                    }).catch(err => err)
            }
        })
}

const deleteEvent = (id) => {
    const URL = `${BASE_SERVER_URL}/event/${id}`

    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            return axios.delete(URL, config)
                .then(ret => {
                    console.log(ret.data)
                    // delete associated image
                    if (ret.data.deletedEvent.fileUrl) {
                        return imageService.deleteImage(imageService.extractFileNamefromFileUrl(ret.data.deletedEvent.fileUrl))
                            .then(delres => {
                                return { articleResponse: ret.data, imageResponse: delres.data }
                            }).catch(err => err.response)
                    } else {
                        return ret
                    }
                }).catch(err => err.response)
        }).catch(err => err.response)
}

const getAllEvents = () => {
    const URL = `${BASE_SERVER_URL}/event`
    return axios.get(URL)
        .then(ret => {
            return ret.data
        }).catch(err => err)

}

const getEvents = (page, limit) => {
    const URL = `${BASE_SERVER_URL}/event?page=${page}&limit=${limit}`
    return axios.get(URL)
        .then(ret => ret.data)
        .catch(err => err)
}

const getUpcomingEvents = (eventType, page, limit) => {
    const URL = `${BASE_SERVER_URL}/event/upcoming/?eventType=${eventType}&page=${page}&limit=${limit}`
    return axios.get(URL)
        .then(ret => ret.data.events)
        .catch(err => err)
}

export default { getEvent, postEvent, updateEvent, deleteEvent, getAllEvents, getEvents, getUpcomingEvents }